import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style.css';
import { getHomeAnnouncement } from '../../../../feature-module/auth/services/apiCalling';
import { toast, ToastContainer } from 'react-toastify';

interface PdfItem {
    id: string;
    doc_id: string;
    image_name: string;
    title_key: string;
    description_key?: string;
    category: string;
}

interface PdfAccordionProps {
    hlanguage: any;
}

interface GroupedPdfs {
    [key: string]: PdfItem[];
}

const PdfAccordion: React.FC<PdfAccordionProps> = ({ hlanguage }) => {
    const [pdfData, setPdfData] = useState<PdfItem[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>('');

    // PDF Configuration - This can be moved to a separate config file or fetched from backend
    const pdfConfig: PdfItem[] = [
        {
            id: '1',
            doc_id: '0cc3536808affff1ca580702859900e9',
            image_name: 'Act_1963',
            title_key: 'pdf_page_Act_1963',
            description_key: 'pdf_page_Act_1963_content',
            category: 'act1963'
        },
        {
            id: '2',
            doc_id: '0cc3536808affff1ca5807028599351a',
            image_name: 'Amendment_2015_I',
            title_key: 'pdf_page_Legal_Amendments',
            description_key: 'pdf_page_Legal_Amendments_content1',
            category: 'amendments'
        },
        {
            id: '3',
            doc_id: '0cc3536808affff1ca580702859914e2',
            image_name: 'Amendment_2015_II',
            title_key: 'pdf_page_Legal_Amendments',
            description_key: 'pdf_page_Legal_Amendments_content2',
            category: 'amendments'
        },
        {
            id: '4',
            doc_id: '0cc3536808affff1ca58070285993320',
            image_name: 'Amendment_2020',
            title_key: 'pdf_page_Legal_Amendments',
            description_key: 'pdf_page_Legal_Amendments_content3',
            category: 'amendments'
        },
        {
            id: '5',
            doc_id: '0cc3536808affff1ca5807028599402d',
            image_name: 'Amendment_2023',
            title_key: 'pdf_page_Legal_Amendments',
            description_key: 'pdf_page_Legal_Amendments_content4',
            category: 'amendments'
        },
        {
            id: '6',
            doc_id: '0cc3536808affff1ca58070285994da7',
            image_name: 'APMC_Rules_1965_GUJ',
            title_key: 'pdf_page_APMC_Rules',
            description_key: 'pdf_page_APMC_Rules_content1',
            category: 'apmc_rules'
        },
        {
            id: '7',
            doc_id: '0cc3536808affff1ca58070285995d5e',
            image_name: 'Daan_Circular',
            title_key: 'pdf_page_General_Circulars',
            description_key: 'pdf_page_General_Circulars_content1',
            category: 'circulars'
        },
        {
            id: '8',
            doc_id: '0cc3536808affff1ca58070285998118',
            image_name: 'Secretory_extension',
            title_key: 'pdf_page_General_Circulars',
            description_key: 'pdf_page_General_Circulars_content2',
            category: 'circulars'
        },
        {
            id: '9',
            doc_id: '0cc3536808affff1ca58070285994da7',
            image_name: 'Circular_checklist',
            title_key: 'pdf_page_General_Circulars',
            description_key: 'pdf_page_General_Circulars_content3',
            category: 'circulars'
        },
        {
            id: '10',
            doc_id: '0cc3536808affff1ca58070285996c46',
            image_name: 'Kadda_pratha_circular_1',
            title_key: 'pdf_page_General_Circulars',
            description_key: 'pdf_page_General_Circulars_content4',
            category: 'circulars'
        },
        {
            id: '11',
            doc_id: '0cc3536808affff1ca5807028599774f',
            image_name: 'Kadda_pratha_circular_2',
            title_key: 'pdf_page_General_Circulars',
            description_key: 'pdf_page_General_Circulars_content5',
            category: 'circulars'
        },
        {
            id: '12',
            doc_id: '0cc3536808affff1ca58070285995a57',
            image_name: 'Circular_of_the_Scheme',
            title_key: 'pdf_page_General_Circulars',
            description_key: 'pdf_page_General_Circulars_content6',
            category: 'circulars'
        },
        {
            id: '13',
            doc_id: '0cc3536808affff1ca58070285995d5e',
            image_name: 'Guidlines_of_the_scheme',
            title_key: 'pdf_page_General_Circulars',
            description_key: 'pdf_page_General_Circulars_content7',
            category: 'circulars'
        },
        {
            id: '14',
            doc_id: '0cc3536808affff1ca58070285998127',
            image_name: 'Vargikaran_paripatr_circular',
            title_key: 'pdf_page_General_Circulars',
            description_key: 'pdf_page_General_Circulars_content8',
            category: 'circulars'
        }
    ];

    useEffect(() => {
        loadPdfData();
    }, []);

    const loadPdfData = () => {
        try {
            // If you want to fetch from backend in future, replace this with API call
            // For now, we're using the config directly
            setPdfData(pdfConfig);
            setLoading(false);
        } catch (err) {
            setError('Failed to load PDF data');
            setLoading(false);
        }
    };

    const handleViewPdf = async (doc_id: string, image_name: string) => {
        try {
            const response = await getHomeAnnouncement(doc_id, image_name);
            
           
            if (response && response.data) {
                // Construct the URL
                const pdfUrl = `${process.env.REACT_APP_BASE_URL}/superadmin/get-image/${doc_id}/${image_name}`;
                window.open(pdfUrl, "_blank");
            }
        } catch (err) {
            // console.error('Error opening PDF:', err);
            // alert('Failed to open PDF. Please try again.');
            toast.error('Failed to open PDF. Please try again.', {
                position: "top-right",
                autoClose: 3000,
            });
        }
    };

    // Group PDFs by category
    const groupedPdfs: GroupedPdfs = pdfData.reduce((acc: GroupedPdfs, pdf) => {
        if (!acc[pdf.category]) {
            acc[pdf.category] = [];
        }
        acc[pdf.category].push(pdf);
        return acc;
    }, {});

    if (loading) {
        return (
            <div className="container-fluid py-5 w-100" style={{ backgroundColor: "white" }}>
                <div className="container text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container-fluid py-5 w-100" style={{ backgroundColor: "white" }}>
                <div className="container">
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container-fluid py-5 w-100" style={{ backgroundColor: "white" }}>
            <div className="container">
                <div className="text-center mb-5">
                    <h1 className="fw-bold" style={{
                        fontSize: "clamp(1.5rem, 4vw, 2.5rem)",
                        color: "#1A5319"
                    }}>
                        <span>
                            {hlanguage?.pdf_page_headers1}
                        </span>
                        <p className='text-secondary'
                            style={{
                                fontSize: "clamp(1rem, 3vw, 1.4rem)",
                                color: "#696969"
                            }}>
                            {hlanguage?.pdf_page_headers2}
                        </p>
                    </h1>
                </div>

                <div className="row g-4">
                    <div className="col-12 col-lg-12">
                        <div className="h-50 row g-4">
                            <div className="accordion" id="accordionExample">

                                {/* Act 1963 */}
                                {groupedPdfs.act1963 && groupedPdfs.act1963.length > 0 && (
                                    <div className="accordion-item mb-2 p-2 shadow-sm">
                                        <h2 className="accordion-header" id="headingOne">
                                            <button 
                                                className="accordion-button accordion-button-custmize" 
                                                type="button" 
                                                style={{ fontSize: "1.1rem" }} 
                                                data-bs-toggle="collapse" 
                                                data-bs-target="#collapseOne" 
                                                aria-expanded="true" 
                                                aria-controls="collapseOne"
                                            >
                                                {hlanguage?.pdf_page_Act_1963}
                                            </button>
                                        </h2>
                                        <div 
                                            id="collapseOne" 
                                            className="accordion-collapse collapse show" 
                                            aria-labelledby="headingOne" 
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="accordion-body">
                                                {groupedPdfs.act1963.map((pdf) => (
                                                    <div
                                                        key={pdf.id}
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "10px"
                                                        }}
                                                    >
                                                        <i
                                                            className="fa fa-file-pdf"
                                                            style={{ color: "#b4c2d9", fontSize: "20px" }}
                                                        ></i>
                                                        <span className='text-secondary' style={{ flex: 1, fontSize: "1.0rem" }}>
                                                            {pdf.description_key && hlanguage?.[pdf.description_key]}
                                                        </span>
                                                        <button
                                                            type='button'
                                                            className='btn btn-link'
                                                            onClick={() => handleViewPdf(pdf.doc_id, pdf.image_name)}
                                                        >
                                                            {hlanguage?.view_pdf}
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Legal Amendments */}
                                {groupedPdfs.amendments && groupedPdfs.amendments.length > 0 && (
                                    <div className="accordion-item mb-2 p-2 shadow-sm">
                                        <h2 className="accordion-header" id="headingTwo">
                                            <button 
                                                className="accordion-button accordion-button-custmize collapsed" 
                                                style={{ fontSize: "1.1rem" }} 
                                                type="button" 
                                                data-bs-toggle="collapse" 
                                                data-bs-target="#collapseTwo" 
                                                aria-expanded="false" 
                                                aria-controls="collapseTwo"
                                            >
                                                {hlanguage?.pdf_page_Legal_Amendments}
                                            </button>
                                        </h2>
                                        <div 
                                            id="collapseTwo" 
                                            className="accordion-collapse collapse" 
                                            aria-labelledby="headingTwo" 
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="accordion-body">
                                                {groupedPdfs.amendments.map((pdf) => (
                                                    <div 
                                                        key={pdf.id}
                                                        style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}
                                                    >
                                                        <i className="fa fa-file-pdf" style={{ color: "#b4c2d9", fontSize: "20px" }}></i>
                                                        <span className='text-secondary' style={{ flex: 1, fontSize: "1.0rem" }}>
                                                            {pdf.description_key && hlanguage?.[pdf.description_key]}
                                                        </span>
                                                        <button
                                                            type='button'
                                                            className='btn btn-link'
                                                            onClick={() => handleViewPdf(pdf.doc_id, pdf.image_name)}
                                                        >
                                                            {hlanguage?.view_pdf}
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* APMC Rules */}
                                {groupedPdfs.apmc_rules && groupedPdfs.apmc_rules.length > 0 && (
                                    <div className="accordion-item mb-2 p-2 shadow-sm">
                                        <h2 className="accordion-header" id="headingThree">
                                            <button 
                                                className="accordion-button accordion-button-custmize collapsed" 
                                                style={{ fontSize: "1.1rem" }} 
                                                type="button" 
                                                data-bs-toggle="collapse" 
                                                data-bs-target="#collapseThree" 
                                                aria-expanded="false" 
                                                aria-controls="collapseThree"
                                            >
                                                {hlanguage?.pdf_page_APMC_Rules}
                                            </button>
                                        </h2>
                                        <div 
                                            id="collapseThree" 
                                            className="accordion-collapse collapse" 
                                            aria-labelledby="headingThree" 
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="accordion-body">
                                                {groupedPdfs.apmc_rules.map((pdf) => (
                                                    <div 
                                                        key={pdf.id}
                                                        style={{ display: "flex", alignItems: "center", gap: "10px" }}
                                                    >
                                                        <i className="fa fa-file-pdf" style={{ color: "#b4c2d9", fontSize: "20px" }}></i>
                                                        <span className='text-secondary' style={{ flex: 1, fontSize: "1.0rem" }}>
                                                            {pdf.description_key && hlanguage?.[pdf.description_key]}
                                                        </span>
                                                        <button
                                                            type='button'
                                                            className='btn btn-link'
                                                            onClick={() => handleViewPdf(pdf.doc_id, pdf.image_name)}
                                                        >
                                                            {hlanguage?.view_pdf}
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* General Circulars */}
                                {groupedPdfs.circulars && groupedPdfs.circulars.length > 0 && (
                                    <div className="accordion-item mb-2 p-2 shadow-sm">
                                        <h2 className="accordion-header" id="headingFour">
                                            <button 
                                                className="accordion-button accordion-button-custmize collapsed" 
                                                style={{ fontSize: "1.1rem" }} 
                                                type="button" 
                                                data-bs-toggle="collapse" 
                                                data-bs-target="#collapseFour" 
                                                aria-expanded="false" 
                                                aria-controls="collapseFour"
                                            >
                                                {hlanguage?.pdf_page_General_Circulars}
                                            </button>
                                        </h2>
                                        <div 
                                            id="collapseFour" 
                                            className="accordion-collapse collapse" 
                                            aria-labelledby="headingFour" 
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="accordion-body">
                                                {groupedPdfs.circulars.map((pdf) => (
                                                    <div 
                                                        key={pdf.id}
                                                        style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}
                                                    >
                                                        <i className="fa fa-file-pdf" style={{ color: "#b4c2d9", fontSize: "20px" }}></i>
                                                        <span className='text-secondary' style={{ flex: 1, fontSize: "1.0rem" }}>
                                                            {pdf.description_key && hlanguage?.[pdf.description_key]}
                                                        </span>
                                                        <button
                                                            type='button'
                                                            className='btn btn-link'
                                                            onClick={() => handleViewPdf(pdf.doc_id, pdf.image_name)}
                                                        >
                                                            {hlanguage?.view_pdf}
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};

export default PdfAccordion;